import { AlertBar } from '#GameFrontend/components/ui/AlertBar/AlertBar';
import { Button } from '#GameFrontend/components/ui/button';
import { socket } from '#GameFrontend/services/socket';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
const Main: React.FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
	const { emailIdentifier, hash } = useParams();
	const [error, setError] = useState<string>('');
	const [success, setSuccess] = useState<string>('');
	const [isAlertVisible, setIsAlertVisible] = useState<boolean>(false);
	const [isSuccessAlertVisible, setIsSuccessAlertVisible] = useState<boolean>(false);
	const [isVerifying, setIsVerifying] = useState<boolean>(false);
	const [registrationClosed, setRegistrationClosed] = useState<boolean>(false);

	useEffect(() => {
		// Clean up function to remove socket listeners
		const cleanup = () => {
			socket.off('User:Verify');
			socket.off('RegistrationStateConfig:Get');
		};

		// Check registration state
		socket.emit('RegistrationStateConfig:Get');
		socket.on('RegistrationStateConfig:Get', (data) => {
			if (data.success) {
				setRegistrationClosed(data.data.registrationClosed);
			}
		});

		// Check if we have both required parameters for verification
		if (emailIdentifier && hash) {
			if (window.location.pathname.includes('/verify/')) {
				setIsVerifying(true);

				socket.on('User:Verify', (data) => {
					setIsVerifying(false);
					if (data.success) {
						setSuccess(t('register.verify.success'));
						setIsSuccessAlertVisible(true);
						// Redirect to main page after 3 seconds
						setTimeout(() => {
							navigate('/');
						}, 3000);
					} else {
						setError(data.message);
						setIsAlertVisible(true);
					}
				});

				// Emit verification request with both parameters
				socket.emit('User:Verify', { emailIdentifier, hash });
			}
		}

		// Cleanup on unmount or when location changes
		return cleanup;
	}, [emailIdentifier, hash, navigate, registrationClosed]);

	const register = () => {
		navigate('/register');
	};

	if (isVerifying) {
		return (
			<div className="flex justify-center items-center min-h-[50vh]">
				<div className="text-center">
					<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brown-400 mx-auto mb-4"></div>
					<p className="text-brown-400 text-lg">{t('register.verify.loading')}</p>
				</div>
			</div>
		);
	}

	return (
		<>
			{error && (
				<AlertBar
					type="error"
					message={error}
					isVisible={isAlertVisible}
					setIsVisible={setIsAlertVisible}
					autoClose={false}
				/>
			)}
			{success && (
				<AlertBar
					type="success"
					message={success}
					isVisible={isSuccessAlertVisible}
					setIsVisible={setIsSuccessAlertVisible}
					autoClose={true}
					autoCloseTime={3000}
				/>
			)}
			<div className="container mx-auto px-4 flex flex-col">
				<div className="flex flex-grow lg:grid lg:grid-cols-2 justify-center items-end lg:items-start mb-16 lg:mb-0">
					{/* First Container */}
					<div className="flex lg:flex-grow items-center lg:items-start justify-center z-10 text-center">
						<div className="text-center">
							<h1 className="text-[3vh] lg:text-4xl text-brown-400 lg:mb-4 text-shadow-white lg:text-shadow-none">
								<Trans
									i18nKey="main.header"
									components={{
										br: <br />,
									}}
								></Trans>
							</h1>
							{!registrationClosed ? (
								<Button
									className="mt-4 px-[4vh] lg:px-8 py-[3vh] lg:py-8 text-[6vw] lg:text-3xl orange-solid-button rounded-[15px] shadow-md"
									onClick={register}
								>
									{t('main.register.button')}
								</Button>
							) : (
								<Button
									className="mt-4 px-[4vh] lg:px-8 py-[3vh] lg:py-8 text-[6vw] lg:text-3xl orange-solid-button rounded-[15px] shadow-md"
									disabled
								>
									{t('main.register.closed')}
								</Button>
							)}
						</div>
					</div>

					{/* Second Container */}
					<div className="w-full lg:flex-grow inset-0 z-0 lg:z-auto hidden lg:flex lg:mt-[-25%]">
						<img
							src={require('#GameFrontend/unauthorized/assets/main/horses_desktop.png')}
							alt="horsi"
							className="h-full w-full object-contain"
						/>
					</div>
				</div>
			</div>
		</>
	);
};

export default Main;
